//ユーザーの役割が「表示のみ」の場合403エラーを表示
export default ({ store, error }) => {
  if (store.state.user.role === 'viewer') {
    error({ statusCode: 403 })
  }
}
